/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExhibitorDto } from '../../models/exhibitor-dto';

export interface ExhibitorControllerFindAllV1$Params {
}

export function exhibitorControllerFindAllV1(http: HttpClient, rootUrl: string, params?: ExhibitorControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ExhibitorDto>>> {
  const rb = new RequestBuilder(rootUrl, exhibitorControllerFindAllV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ExhibitorDto>>;
    })
  );
}

exhibitorControllerFindAllV1.PATH = '/api/v1/exhibitor';
